import React, { useRef } from "react";
import { useField, Field } from "formik";
import { AppInputPasswordProps } from "src/commun/composants/formulaire/AppInputPassword/AppInputPassword";
import useScrollToError from "src/commun/composants/formulaire/formik/hooks/useScrollToError";
import AppInputPassword from "src/commun/composants/formulaire/AppInputPassword/AppInputPassword";

export type AppInputFormikPasswordProps = Omit<AppInputPasswordProps, "onChange" | "value" | "error"> & { formulaireSoumis?: boolean };

const AppInputPasswordFormik = ({ name, formulaireSoumis = false, ...reste }: AppInputFormikPasswordProps) => {
  const [, { error, touched }] = useField(name);
  const ref = useRef(undefined);
  useScrollToError(name, ref);

  return (
    <Field fieldRef={ref} name={name} error={error} touched={formulaireSoumis || touched} as={AppInputPassword} {...reste} />
  );
};

export default AppInputPasswordFormik;
